var src,srcset,wnw_windowWidth,wnw_windowHeight,critical2,lazyBackground,lazyIframe,lazybg,s,i,flag=1,external_single_loaded=1;

document.addEventListener("DOMContentLoaded", function() {
	wnw_windowWidth=screen.width;
	wnw_windowHeight=screen.height;
	lazyLoadImg2();
	lazyLoadBackground2();
	window.addEventListener("scroll", function() {
		wnw_init();
	});
	window.addEventListener("mousemove", function() {
		wnw_init();
	});
	window.addEventListener("touchstart", function() {
		wnw_init();
	});
});

function wnw_init() {
	//lazyLoadCss();
	lazyLoadStyle();
	lazyLoadImg();
	lazyLoadBackground();
	lazyLoadIframe();
	if (flag) {
		flag = 0;
		load_all_js();
	}
}

function insertAfter(newNode, referenceNode) {
	referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}

function lazyLoadImg() {
	var imgs = document.querySelectorAll("img[data-src2]");

	for (i = 0; i < imgs.length; i++) {
        if (wnw_windowWidth < 600) {
			src = (imgs[i].dataset.mobsrc2 === undefined) ? imgs[i].dataset.src2 : imgs[i].dataset.mobsrc2;
        } else {
			src = (imgs[i].dataset.src2 === undefined) ? imgs[i].src : imgs[i].dataset.src2;
        }
        if (src != null && src != "") {
			imgs[i].src = src;
        }
		delete imgs[i].dataset.src2;
		delete imgs[i].dataset.mobsrc2;
	}
	var imgs = document.querySelectorAll("img[data-srcset2]");

	for (i = 0; i < imgs.length; i++) {
        srcset = imgs[i].getAttribute("data-srcset2") ? imgs[i].getAttribute("data-srcset2") : "";
        if (srcset != null && srcset != "") {
			imgs[i].srcset = srcset;
        }
		delete imgs[i].dataset.srcset2;
	}
}

function lazyLoadImg2() {
	var imgs = document.querySelectorAll("img[data-src3]");

	for (i = 0; i < imgs.length; i++) {
		var elemRect = imgs[i].getBoundingClientRect();
        if (elemRect.top != 0 && elemRect.top - wnw_windowHeight < 1) {
			if (wnw_windowWidth < 600) {
				src = (imgs[i].dataset.mobsrc3 === undefined) ? imgs[i].dataset.src3 : imgs[i].dataset.mobsrc3;
			} else {
				src = (imgs[i].dataset.src3 === undefined) ? imgs[i].src : imgs[i].dataset.src3;
			}
			if (src != null && src != "") {
				imgs[i].src = src;
			}
		}
		delete imgs[i].dataset.src3;
		delete imgs[i].dataset.mobsrc3;
	}
	var imgs = document.querySelectorAll("img[data-srcset3]");

	for (i = 0; i < imgs.length; i++) {
		var elemRect = imgs[i].getBoundingClientRect();
        if (elemRect.top != 0 && elemRect.top - wnw_windowHeight < 1) {
			srcset = imgs[i].getAttribute("data-srcset3") ? imgs[i].getAttribute("data-srcset3") : "";
			if (srcset != null && srcset != "") {
				imgs[i].srcset = srcset;
			}
		}
		delete imgs[i].dataset.srcset3;
	}
}

function lazyLoadBackground() {
	lazyBackground = document.querySelectorAll("[data-style2]");
	lazyBackground.forEach(function(a) {
		var elemRect = a.getBoundingClientRect();
        if (elemRect.top != 0 && elemRect.top - wnw_windowHeight < 100) {
            if (wnw_windowWidth < 600) {
                lazybg = (a.dataset.mobstyle2 === undefined) ? a.dataset.style2 : a.dataset.mobstyle2;
            } else {
                lazybg = (a.dataset.style2 === undefined) ? a.style : a.dataset.style2;
            }
            if (lazybg != null && lazybg != "") {
                a.style = lazybg;
            }
		}
		delete a.dataset.style2;
		delete a.dataset.mobstyle2;
	});
}

function lazyLoadBackground2() {
	lazyBackground = document.querySelectorAll("[data-style3]");
	lazyBackground.forEach(function(a) {
		var elemRect = a.getBoundingClientRect();
        if (elemRect.top != 0 && elemRect.top - wnw_windowHeight < 1) {
            if (wnw_windowWidth < 600) {
                lazybg = (a.dataset.mobstyle3 === undefined) ? a.dataset.style3 : a.dataset.mobstyle3;
            } else {
                lazybg = (a.dataset.style3 === undefined) ? a.style : a.dataset.style3;
            }
            if (lazybg != null && lazybg != "") {
                a.style = lazybg;
            }
		}
		delete a.dataset.style3;
		delete a.dataset.mobstyle3;
	});
}

function lazyLoadCss() {
	setTimeout(function() {
		critical2 = document.querySelectorAll(".cls_css");
		critical2.forEach(function(a) {
			a.remove();
		});
	});

	var lazyLink = document.querySelectorAll("link[data-href]");
	for (i = 0; i < lazyLink.length; i++) {
		var css_element = document.createElement("link");
		css_element.href = lazyLink[i].getAttribute("data-href");
		css_element.rel = "stylesheet";
		lazyLink[i].parentNode.insertBefore(css_element, lazyLink[i]);
		delete lazyLink[i].dataset.href;
		lazyLink[i].parentNode.removeChild(lazyLink[i]);
	}

	setTimeout(function() {
		critical2 = document.querySelectorAll(".critical2");
		critical2.forEach(function(a) {
			a.remove();
		});
	}, 8000);
}

function lazyLoadStyle() {
	var lazyStyle = document.querySelectorAll("style[type=lazyload2]");
	for (i = 0; i < lazyStyle.length; i++) {
		var style_element = document.createElement("style");
		style_element.innerHTML = lazyStyle[i].innerHTML;
		lazyStyle[i].parentNode.insertBefore(style_element, lazyStyle[i]);
		lazyStyle[i].parentNode.removeChild(lazyStyle[i]);
	}
}

function lazyLoadIframe() {
	lazyIframe = document.querySelectorAll("iframe");
	lazyIframe.forEach(function(a) {
		if (a.dataset.src2 != null && a.dataset.src2 != "") {
			a.src = a.dataset.src2;
			delete a.dataset.src2;
		}
	});
}

function w3_load_js_uri(static_script) {
	var ext_js_element = document.createElement("script");
	if (typeof(static_script.attributes) != "undefined") {
		for (var att, i3 = 0, atts = static_script.attributes, n3 = atts.length; i3 < n3; i3++) {
			att = atts[i3];
			if (att.nodeName != "data-src2" && att.nodeName != "type") {
				ext_js_element.setAttribute(att.nodeName, att.nodeValue);
			}
		}
	}
	ext_js_element.src = static_script.getAttribute("data-src2");
	insertAfter(ext_js_element, static_script);
	delete static_script.dataset.src2;
	delete static_script.type;
	static_script.parentNode.removeChild(static_script);
	return ext_js_element;
}

function w3_load_inline_js_single(script) {
	if (!external_single_loaded) {
		setTimeout(function() {
			w3_load_inline_js_single(script);
		}, 200);
		return false;
	}
	s = document.createElement("script");
	for (var i2 = 0; i2 < script.attributes.length; i2++) {
		var attrib = script.attributes[i2];
		if (attrib.name != "type") {
			s.setAttribute(attrib.name, attrib.value);
		}
	}
	s.innerHTML = script.innerHTML;
	insertAfter(s, script);
	script.parentNode.removeChild(script);
}

function lazyLoadScripts() {
	var static_script = document.querySelectorAll("script[type=lazyload2]");
	if (static_script.length < 1) {
      	document.body.classList.add("wnw_loaded");
		fullJSLoadedCB();
		return;
	}
	if (static_script[0].getAttribute("data-src2") !== null) {
		var js_obj = w3_load_js_uri(static_script[0]);
		js_obj.onload = function() {
			lazyLoadScripts();
		};
		js_obj.onerror = function() {
			lazyLoadScripts();
		};
	} else {
		w3_load_inline_js_single(static_script[0]);
		lazyLoadScripts();
	}
}

function wnwAnalytics() {
	var script2 = document.querySelectorAll(".analytics");
	script2.forEach(function(analyticsScript) {
		trekkie.integrations=false;
		s = document.createElement("script");
		s.innerHTML = analyticsScript.innerHTML;
		insertAfter(s, analyticsScript);
		analyticsScript.parentNode.removeChild(analyticsScript);
	});
}

function load_all_js() {
	if(Shopify.designMode || window.location.href.indexOf("/cart") > -1 || window.location.href.indexOf("/checkout") > -1) {
		console.log("No-optimization");
	} else {
		console.log("Yes-optimization");
		setTimeout(function() {
			wnwAnalytics();
		}, 100);
		setTimeout(function() {
			var wnw_load_event = document.createEvent("Event");
			wnw_load_event.initEvent("wnw_load", true, true);
			window.document.dispatchEvent(wnw_load_event);
		}, 500);
		setTimeout(function() {
			var DOMContentLoaded2_event = document.createEvent("Event");
			DOMContentLoaded2_event.initEvent("DOMContentLoaded2", true, true);
			window.document.dispatchEvent(DOMContentLoaded2_event);
		}, 5000);
	}

	lazyLoadScripts();

	setInterval(function() {
		lazyLoadImg();
		lazyLoadIframe();
    });
}

function fullJSLoadedCB() {
	setTimeout(function() {
	});
}